/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Frustrating_Too_MuchInputs */

const en_onboarding_frustrating_too_much = /** @type {(inputs: Onboarding_Frustrating_Too_MuchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too much reading material`)
};

const es_onboarding_frustrating_too_much = /** @type {(inputs: Onboarding_Frustrating_Too_MuchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiado material de lectura`)
};

/**
* | output |
* | --- |
* | "Too much reading material" |
*
* @param {Onboarding_Frustrating_Too_MuchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_frustrating_too_much = /** @type {((inputs?: Onboarding_Frustrating_Too_MuchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Frustrating_Too_MuchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_frustrating_too_much(inputs)
	return en_onboarding_frustrating_too_much(inputs)
});